import { render, staticRenderFns } from "./ServiceVideoContainer.vue?vue&type=template&id=255c6c81&scoped=true"
import script from "./ServiceVideoContainer.vue?vue&type=script&lang=js"
export * from "./ServiceVideoContainer.vue?vue&type=script&lang=js"
import "./ServiceVideoContainer.vue?vue&type=style&index=0&id=255c6c81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c6c81",
  null
  
)

export default component.exports